import watchInvestorProfile from './investorProfile'

export default watchInvestorProfile
